<script lang="ts">
  import type { RecommendedProduct } from "../../../interfaces/RecommendationProduct"

  import { formatNumber } from "../../../util/formatNumber"

  import Text from "../../Common/Text.svelte"

  export let product: RecommendedProduct
</script>

{#if product.currentPrice}
  <div class="product-price-container">
    <Text class="product-current-price">
      ${formatNumber(product.currentPrice)}
    </Text>
    {#if product.oldPrice}
      <Text class="product-old-price">
        (Originally ${formatNumber(product.oldPrice)})
      </Text>
    {/if}
  </div>
{/if}
